module.exports = __webpack_public_path__ + "static/media/driver-image.ef7a73d0.jpg";